import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TabsetComponent } from '../tabset';

@UntilDestroy()
@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: '[appTabsetOutlet]',
    templateUrl: './tabset-outlet.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TabsetOutletComponent implements AfterViewInit {
    @Input('appTabsetOutlet') public tabset: TabsetComponent;

    public constructor(private changeDetectorRef: ChangeDetectorRef) {}

    public ngAfterViewInit() {
        this.tabset.tabChanged$.pipe(untilDestroyed(this)).subscribe(() => {
            this.changeDetectorRef.detectChanges();
        });
    }
}
